import axios from "axios";
import { APP_API_BASE } from "../../../shared/utils/apiConfig";
import type { RuleBlock, RulesResponse } from "../types";

// Fetches the rules document in the given language.
// The signal lets the caller cancel the request (language change or unmount).
export const getRules = async (
    language: string,
    signal?: AbortSignal
): Promise<RuleBlock[]> => {
    const { data } = await axios.get<RulesResponse>(`${APP_API_BASE}/rules`, {
        params: { language },
        signal
    });

    return data.success ? data.content : [];
};